import React from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

function AdminUpdateCampaginAppointmentForm() {
  const { id } = useParams();
  const history = useHistory();
  const [appointmentDetails, setAppointmentDetails] = React.useState({});
  const [error, setError] = React.useState();

  const fetchAppointmentData = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_BASE}/appointment/get?id=${id}`,
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_TOKEN}`,
        },
      }
    );
    setAppointmentDetails(result.data);
  };

  React.useEffect(() => {
    fetchAppointmentData();
  }, []);

  const changeHandler = (e) => {
    setAppointmentDetails({
      ...appointmentDetails,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE}/appointment/update?id=${id}`,
        appointmentDetails,
        {
          headers: {
            Authorization: `Basic ${process.env.REACT_APP_TOKEN}`,
          },
        }
      );
      toast.success("Appointment updated successfully!");
      history.push("/evenimente/mostre");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update appointment.");
    }
  };

  return (
    <div className="update-form-container">
      <h2>Actualizare înscriere</h2>
      <form onSubmit={submitHandler}>
        <div className="form-field">
          <label>Nume</label>
          <input
            type="text"
            name="name"
            value={appointmentDetails.name || ""}
            onChange={changeHandler}
          />
        </div>
        <div className="form-field">
          <label>Prenume</label>
          <input
            type="text"
            name="lastname"
            value={appointmentDetails.lastname || ""}
            onChange={changeHandler}
          />
        </div>
        <div className="form-field">
          <label>Telefon</label>
          <input
            type="text"
            name="phone"
            value={appointmentDetails.phone || ""}
            onChange={changeHandler}
          />
        </div>
        <div className="form-field">
          <label>Oraş</label>
          <input
            type="text"
            name="city"
            value={appointmentDetails.city || ""}
            onChange={changeHandler}
          />
        </div>
        <div className="form-field">
          <label>Încercat</label>
          <input
            type="text"
            name="hasTriedEssentialOils"
            value={appointmentDetails.hasTriedEssentialOils || ""}
            onChange={changeHandler}
          />
        </div>
        <div className="form-field">
          <label>Cont</label>
          <input
            type="text"
            name="hasDoTerraAccount"
            value={appointmentDetails.hasDoTerraAccount || ""}
            onChange={changeHandler}
          />
        </div>
        <div className="form-field">
          <label>Provocări</label>
          <input
            type="text"
            name="challenges"
            value={appointmentDetails.challenges || ""}
            onChange={changeHandler}
          />
        </div>
        <div className="form-field">
          <label>Mostre</label>
          <input
            type="text"
            name="samples"
            value={appointmentDetails.samples || ""}
            onChange={changeHandler}
          />
        </div>
        <button type="submit">Actualizeazǎ</button>
      </form>
    </div>
  );
}

export default AdminUpdateCampaginAppointmentForm;
